<template>
  <div id="index">
    <!-- 头部 -->
    <HeaderTop :headIndex="headIndex" :searchText="searchText" ref="header" @searchFun="searchFun"></HeaderTop>
    <!-- 推荐内容 -->
    <div class="main wrap flex_between">
      <!-- 推荐 -->
      <div class="recommended">
        <div class="recommended_title flex_center">
          <span class="flex_center recommended_title_li" :class="{'selected':recommended_index == 1}"
            @click.stop="recommended_index = 1">发现</span>

        </div>
        <div class="">
          <listLi :list_arr="list_arr" ref="listLi" :is_loading="is_loading" @detailsFun="detailsFun"></listLi>
        </div>
        <div class="complete" @click="moreFun" v-if="is_more && list_arr.length>0">点击加载更多</div>
      </div>
      <!-- 热门 -->
      <div class="hot_div hot">
        <div class="hot_title flex_center">
          <i><img src="@/assets/img/hot.png" alt=""></i>
          <span class="flex_center">热门</span>
        </div>
        <div class="">
          <hot :list="hotList_arr" @detailsFun="detailsFun"></hot>
        </div>
      </div>

    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderTop from '@/components/assembly/HeaderTop.vue';//头部模块
  import Footer from '@/components/assembly/Footer.vue';//尾部模块
  import hot from '@/components/assembly/hot.vue';//热门模块
  import listLi from '@/components/assembly/listLi.vue';//列表数据模块
  import "@/assets/js/swiper.animate1.0.3.min.js";
  // import "@/assets/js/wx_jsapi.js";
  import wx from 'weixin-js-sdk';

  import "@/assets/js/currency.js";
  import "@/assets/css/animate.min.css";
  import "@/assets/css/reset.css";

  //pc端
  // import "@/assets/css/index_min768.css";


  export default {
    name: 'index',
    data() {
      return {
        IMG_URL: this.$IMG_URL,
        recommended_index: 1,//导航 index

        page: 1,//翻页
        list_arr: [],//列表数组
        hotList_arr: [],//热门列表
        searchText: '',//搜索内容
        headIndex: 1,//搜索内容
        is_more:true,
        is_loading:false,
      }
    },
    computed: {

    },
    components: {
      HeaderTop, Footer, hot, listLi
    },
    watch: {

    },
    methods: {
      searchFun(text) {
        this.searchText = text;
        this.page = 1;
        this.getList()
      },
      detailsFun(id) {//查看详情
        this.$router.push({ path: '/column_details', query: { id: id, head_index: 2 } });
      },
      getList() {//获取列表数据
        let that = this;
        that.is_loading = false;
        if (this.page == 1) {
          this.list_arr = [];
        }
        this.$post('index-search', {
          type: 1,
          member_id: this.USER().id,
          limit: 10,
          keyword: this.searchText,
          page: this.page,
        }).then(res => {
           
           
          that.is_loading = true;
          if(res.data.data.length<=0){
              that.is_more = false;
          }else{
            that.is_more = true;
          }
          that.list_arr = that.list_arr.concat(res.data.data);
          that.$nextTick(()=>{
            that.$refs.listLi.videoFun();
          })
        })
      },
      getHotList() {//获取热门列表数据
        let that = this;
        this.$post('news_recomm', {
          type: 4,
          limit: 10,
          page: 1,
        }).then(res => {
          let data = res.data.data;
          that.hotList_arr = data;
        })
      },
      details(id, record_url) {//跳转页面
        if (this._isMobile()) {
          // alert("手机端");
          if (this.selectBox_index == 1) {//直播
            //   this.$router.push({path: 'min_move',query:{ id:id,url:record_url}});
          } else {
            //   this.$router.push({path: 'min_record',query:{ id:id,url:record_url}});
          }
        } else {
          // alert("pc端");
          if (this.selectBox_index == 1) {//直播
            //   this.$router.push({path: 'pc_move',query:{ id:id,url:record_url}});
          } else {
            //   this.$router.push({path: 'pc_record',query:{ id:id,url:record_url}});
          }
        }
      },
      moreFun(){
        this.page++;
        this.getList();
      },
    },
    created() {

    },
    mounted() {
      if (this.$route.query.searchText) {
        this.searchText = this.$route.query.searchText;
        this.$refs.header.headerFun(this.searchText);
      }
      if (this.$route.query.headIndex) {
        this.headIndex = this.$route.query.headIndex;
      }
      document.title = '麻醉眼界';
      this.getHotList();
      this.getList();

      // this.$router.replace("/index");
      if (this._isMobile()) {
        // alert("手机端");
        this.$router.replace('/m_index');
      } else {
        // alert("pc端");
        // this.$router.replace('/index');

      }
      let that = this;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $(document).height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getList();
        }
      });
    }
  }
</script>
<style>


</style>
<style scoped>
  .main {
    max-width: 1280px;
    min-width: 865px;
    margin: 0 auto;
    width: 1280px;
    position: relative;
  }

  #index {
    background: #F5F3FB;
    min-width: 1280px;
  }

  .main {
    padding: 13px 0;
    align-items: flex-start;
  }

  /* 推荐导航 */
  .recommended {
    width: 895px;
    background: #fff;
    border-radius: 10px;

  }

  .recommended .recommended_title {
    padding: 0 50px;
    border-bottom: .005rem solid #999999;
  }

  .recommended .recommended_title .recommended_title_li {
    height: 70px;
    margin-right: 50px;
    padding: 0 6px;
    font-size: 18px;
    cursor: pointer;
    color: #333;
  }

  .recommended .recommended_title .recommended_title_li.selected {
    position: relative;
    font-weight: bold;
  }

  .recommended .recommended_title .recommended_title_li.selected::after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    bottom: 1px;
    height: 2px;
    background: #F24D5B;
  }

  .recommended_list {
    padding: 0 51px;
  }


  /* 热门 */
  .hot {
    width: 334px;
    background: #fff;
    border-radius: 10px;
      /* position: fixed;
        right: calc((100% - 1280px) / 2);
        top: 74px; */
        position: absolute;
        right: 0;
        top: 13px;
  }

  .hot .hot_title {
    border-bottom: .005rem solid #999999;
  }

  .hot .hot_title>i {
    width: 15px;
    margin-right: 11px;
  }

  .hot .hot_title>span {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    height: 70px;
  }

</style>


// WEBPACK FOOTER //
// src/components/pc_viwe/found.vue